module.exports = __webpack_public_path__ + "static/media/Handwritten.4fd05fa6.png";